// PGCET MCA Mock 9 — General Awareness (questions 71–90)
const pgcetmcaGeneralAwareness = [
  {
    id: 71,
    question: "Under which Article of the Constitution of India does the President have the power to grant pardons, reprieves, respites or remissions of punishment?",
    options: ["A. Article 72", "B. Article 74", "C. Article 76", "D. Article 123"],
    answer: "A"
  },
  {
    id: 72,
    question: "The President of India can promulgate ordinances when both Houses of Parliament are not in session under",
    options: ["A. Article 72", "B. Article 110", "C. Article 123", "D. Article 143"],
    answer: "C"
  },
  {
    id: 73,
    question: "A joint sitting of both Houses of the Parliament of India is presided over by the",
    options: ["A. President of India", "B. Speaker of the Lok Sabha", "C. Chairman of the Rajya Sabha", "D. Prime Minister"],
    answer: "B"
  },
  {
    id: 74,
    question: "The President of India may seek the advisory opinion of the Supreme Court on a question of law or fact of public importance under",
    options: ["A. Article 131", "B. Article 136", "C. Article 148", "D. Article 143"],
    answer: "D"
  },
  {
    id: 75,
    question: "The Supreme Court of India is established and constituted under which Article of the Constitution?",
    options: ["A. Article 124", "B. Article 214", "C. Article 226", "D. Article 315"],
    answer: "A"
  },
  {
    id: 76,
    question: "As per the Constitution of India, the maximum strength of the Rajya Sabha is",
    options: ["A. 245", "B. 250", "C. 552", "D. 238"],
    answer: "B"
  },
  {
    id: 77,
    question: "Which river is called the 'Sorrow of Bihar' because of its frequent floods and shifting course?",
    options: ["A. Gandak", "B. Son", "C. Kosi", "D. Damodar"],
    answer: "C"
  },
  {
    id: 78,
    question: "The Bhakra Nangal Dam, one of the highest gravity dams in India, is built across the river",
    options: ["A. Beas", "B. Ravi", "C. Chenab", "D. Sutlej"],
    answer: "D"
  },
  {
    id: 79,
    question: "The Sardar Sarovar Dam in Gujarat is constructed on the river",
    options: ["A. Tapi", "B. Narmada", "C. Mahi", "D. Sabarmati"],
    answer: "B"
  },
  {
    id: 80,
    question: "The Hirakud Dam in Odisha, one of the longest earthen dams in the world, is built across the river",
    options: ["A. Mahanadi", "B. Godavari", "C. Krishna", "D. Brahmani"],
    answer: "A"
  },
  {
    id: 81,
    question: "Jim Corbett National Park, established in 1936 as India's first national park, is located in",
    options: ["A. Himachal Pradesh", "B. Uttarakhand", "C. Madhya Pradesh", "D. Uttar Pradesh"],
    answer: "B"
  },
  {
    id: 82,
    question: "Gir National Park in Gujarat is famous as the only natural habitat in the world of the",
    options: ["A. Bengal tiger", "B. One-horned rhinoceros", "C. Asiatic lion", "D. Snow leopard"],
    answer: "C"
  },
  {
    id: 83,
    question: "Bandipur National Park in Karnataka shares its southern boundary with which protected area of Tamil Nadu?",
    options: ["A. Mudumalai National Park", "B. Periyar Tiger Reserve", "C. Silent Valley National Park", "D. Eravikulam National Park"],
    answer: "A"
  },
  {
    id: 84,
    question: "Madhubani painting, known for its intricate line drawings and natural colours, is a traditional folk art of",
    options: ["A. Odisha", "B. Rajasthan", "C. Gujarat", "D. Bihar"],
    answer: "D"
  },
  {
    id: 85,
    question: "Channapatna in Karnataka, often called the 'Toy Town', is famous for its",
    options: ["A. Silk sarees", "B. Brass lamps", "C. Wooden lacquered toys", "D. Sandalwood carvings"],
    answer: "C"
  },
  {
    id: 86,
    question: "Engineers' Day is celebrated in India on 15 September to mark the birth anniversary of",
    options: ["A. Sir M. Visvesvaraya", "B. Homi J. Bhabha", "C. C. V. Raman", "D. Satish Dhawan"],
    answer: "A"
  },
  {
    id: 87,
    question: "Kuvempu, the first Kannada writer to receive the Jnanpith Award, was honoured for his epic work",
    options: ["A. Mookajjiya Kanasugalu", "B. Chikkaveera Rajendra", "C. Naakutanti", "D. Sri Ramayana Darshanam"],
    answer: "D"
  },
  {
    id: 88,
    question: "Basavanna, the 12th-century social reformer of Karnataka, established a spiritual and social assembly known as",
    options: ["A. Brahmo Samaj", "B. Prarthana Samaj", "C. Anubhava Mantapa", "D. Arya Samaj"],
    answer: "C"
  },
  {
    id: 89,
    question: "Which law states that, at constant temperature, the current flowing through a conductor is directly proportional to the potential difference across its ends?",
    options: ["A. Faraday's law", "B. Ohm's law", "C. Coulomb's law", "D. Ampere's law"],
    answer: "B"
  },
  {
    id: 90,
    question: "Which gas is commonly known as 'laughing gas' and is used as a mild anaesthetic?",
    options: ["A. Nitrogen dioxide (NO₂)", "B. Nitric oxide (NO)", "C. Dinitrogen tetroxide (N₂O₄)", "D. Nitrous oxide (N₂O)"],
    answer: "D"
  }
];

export default pgcetmcaGeneralAwareness;
